import { useMemo } from "react";
import { createTheme, darken, lighten } from "@material-ui/core/styles";
import { colorOverride } from "../colorOverrides";
import { createStatusColors } from "../statusColors";
const migrationOverrides = {
    props: {
        MuiTextField: {
            variant: "outlined"
        },
        MuiLink: {
            underline: "always"
        }
    }
};
export function createDployTheme(design, tenant, override) {
    const { designs, themeObject = { palette: {} }, designOverride } = tenant;
    const themeWithOverriddenPalette = {
        ...themeObject,
        palette: { ...themeObject.palette, ...override.palette }
    };
    // createTheme generates light/dark/contrastText colors from the first argument
    let theme = createTheme(themeWithOverriddenPalette, migrationOverrides, override);
    theme.palette.status = createStatusColors(themeObject.palette?.status, theme.palette);
    if (design) {
        theme = designs[design]?.muiTheme(theme) ?? theme;
        theme = designOverride?.(theme) ?? theme;
    }
    theme = colorOverride(theme);
    return theme;
}
export function useDesignSettings(tenant, design, brandTheme = {}) {
    const { palettePrimaryMain, paletteSecondaryMain, paletteAccent1Main, paletteAccent2Main, paletteAccent3Main, paletteAccent4Main, paletteBackgroundDefault, paletteBackgroundDrawer, paletteOverride } = brandTheme;
    const theme = useMemo(() => {
        const overrideTheme = {
            palette: {},
            props: {}
        };
        if (palettePrimaryMain)
            overrideTheme.palette.primary = { main: palettePrimaryMain };
        if (paletteSecondaryMain)
            overrideTheme.palette.secondary = { main: paletteSecondaryMain };
        if (paletteAccent1Main)
            overrideTheme.palette.accent1 = {
                main: paletteAccent1Main,
                light: lighten(paletteAccent1Main, 0.1),
                dark: darken(paletteAccent1Main, 0.5)
            };
        if (paletteAccent2Main)
            overrideTheme.palette.accent2 = {
                main: paletteAccent2Main,
                light: lighten(paletteAccent2Main, 0.1),
                dark: darken(paletteAccent2Main, 0.5)
            };
        if (paletteAccent3Main)
            overrideTheme.palette.accent3 = {
                main: paletteAccent3Main,
                light: lighten(paletteAccent3Main, 0.1),
                dark: darken(paletteAccent3Main, 0.5)
            };
        if (paletteAccent4Main)
            overrideTheme.palette.accent4 = {
                main: paletteAccent4Main,
                light: lighten(paletteAccent4Main, 0.1),
                dark: darken(paletteAccent4Main, 0.5)
            };
        if (paletteBackgroundDefault)
            overrideTheme.palette.background = { default: paletteBackgroundDefault };
        if (paletteBackgroundDrawer)
            overrideTheme.props.Portal = { drawerColor: paletteBackgroundDrawer };
        if (paletteOverride) {
            var alternativePalette = tenant.themeObject?.alternativePalettes?.[paletteOverride];
            if (typeof alternativePalette !== "undefined")
                overrideTheme.palette = alternativePalette;
        }
        return createDployTheme(design, tenant, overrideTheme);
    }, [
        palettePrimaryMain,
        paletteSecondaryMain,
        paletteAccent1Main,
        paletteAccent2Main,
        paletteAccent3Main,
        paletteAccent4Main,
        paletteBackgroundDefault,
        paletteBackgroundDrawer,
        paletteOverride,
        design,
        tenant
    ]);
    return { theme };
}
//# sourceMappingURL=useDesignSettings.js.map